import { SortDirection } from "./types";
import { CardholderTableRow } from "./body/rowGenerator";

export function desc(
  a: CardholderTableRow,
  b: CardholderTableRow,
  orderBy: keyof CardholderTableRow,
): number {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function sort(
  array: CardholderTableRow[],
  cmp: (a: CardholderTableRow, b: CardholderTableRow) => number,
): CardholderTableRow[] {
  const valueIndexMap: [CardholderTableRow, number][] = array.map(
    (el, index) => [el, index],
  );

  valueIndexMap.sort((a, b) =>
    cmp(a[0], b[0]) !== 0 ? cmp(a[0], b[0]) : a[1] - b[1],
  );

  return valueIndexMap.map((el) => el[0]);
}

export function comparator(
  order: SortDirection,
  orderBy: keyof CardholderTableRow,
): (a: CardholderTableRow, b: CardholderTableRow) => number {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
